import React from 'react'
import { Link } from 'gatsby'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

const LinkComponent = ({ title, type, url, children, activeclassname, linkTitle, ...rest }) => {
   if (type === 'internal') {
      return (
         <Link to={url} activeClassName={activeclassname} {...rest} partiallyActive={true} title={linkTitle || ''}>
            {children}
            {title}
         </Link>
      )
   }
   return (
      <OutboundLink href={url} {...rest} target="_blank" title={linkTitle || ''}>
         {children}
         {title}
      </OutboundLink>
   )
}

export default LinkComponent
